const Types = {
    UPDATE_IN_PROGRESS_DRAWINGS: 'UPDATE_IN_PROGRESS_DRAWINGS',
    REMOVE_IN_PROGRESS_DRAWING: 'REMOVE_IN_PROGRESS_DRAWING',
};

const DrawingActions = {
    Types,
    updateInProgressDrawings(contentRevisionId, drawing) {
        return {
            type: Types.UPDATE_IN_PROGRESS_DRAWINGS,
            contentRevisionId,
            drawing,
        };
    },
    removeInProgressDrawing(contentRevisionId) {
        return {
            type: Types.REMOVE_IN_PROGRESS_DRAWING,
            contentRevisionId,
        };
    },
};

export default DrawingActions;
